import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sen-app-installation-time',
  templateUrl: './installation-time.component.html',
  styleUrls: ['./installation-time.component.scss']
})
export class InstallationTimeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
